import { FC } from 'react';
import {
  useSearchParamState,
  serializationOptionsForNumberValue,
  serializationOptionsForStringValue,
  createSerializationOptionsForEnumValue,
} from 'utils/hooks/useSearchParamState';
import { AnalyticsTabs, QueryParamContextState } from 'modules/iterableGoals/types';
import { queryParamKeys } from 'modules/iterableGoals/constants';
import { initalQueryParamContextState, QueryParamContext } from './QueryParamContext';

enum RevenueReportingEvent {
  ITERABLE_PURCHASE = 'iterable_purchase',
}

export const QueryParamContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [goalId] = useSearchParamState({
    searchParamKey: queryParamKeys.goalId,
    stateValueWhenSearchParamIsUnset: initalQueryParamContextState.goalId,
    pushChangesToBrowserHistory: false,
    ...serializationOptionsForNumberValue,
  });

  const [goalName] = useSearchParamState({
    searchParamKey: queryParamKeys.goalName,
    stateValueWhenSearchParamIsUnset: initalQueryParamContextState.goalName,
    ...serializationOptionsForStringValue,
  });

  const [tab, setTab] = useSearchParamState({
    searchParamKey: queryParamKeys.tab,
    stateValueWhenSearchParamIsUnset: initalQueryParamContextState.tab,
    ...createSerializationOptionsForEnumValue({
      enumKeyValueMap: AnalyticsTabs,
      stateValueWhenSearchParamIsInvalid: initalQueryParamContextState.tab,
    }),
  });

  const context: QueryParamContextState = {
    goalId,
    goalName,
    includeRevenue: goalName === RevenueReportingEvent.ITERABLE_PURCHASE,
    includePrevious: true,
    tab,
    setTab,
  };

  return <QueryParamContext.Provider value={context}>{children}</QueryParamContext.Provider>;
};
